import { render } from "./JobNote.vue?vue&type=template&id=b92a96f0&lang=html"
import script from "./JobNote.vue?vue&type=script&lang=js"
export * from "./JobNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__